import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.33325 7.99998C1.33325 4.31808 4.31802 1.33331 7.99992 1.33331C11.6818 1.33331 14.6666 4.31808 14.6666 7.99998C14.6666 11.6819 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6819 1.33325 7.99998ZM8.66659 6.01276C8.66659 5.64457 8.36811 5.34609 7.99992 5.34609C7.63173 5.34609 7.33325 5.64457 7.33325 6.01276V8.00892C7.33325 8.37711 7.63173 8.67559 7.99992 8.67559C8.36811 8.67559 8.66659 8.37711 8.66659 8.00892V6.01276ZM7.99992 9.16664C7.53968 9.16664 7.16658 9.53974 7.16658 9.99998C7.16658 10.4602 7.53968 10.8333 7.99992 10.8333C8.46016 10.8333 8.83325 10.4602 8.83325 9.99998C8.83325 9.53974 8.46016 9.16664 7.99992 9.16664Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }